import React, { Component } from "react";
import styles from "./winterMaintenceMapWrapper.module.scss";
import { withWinterMaintence } from "../../../shared/containers/containerWinterMaintence";
import { states } from "../../../reducers/queriesStates";
import { ColorPicker } from "material-ui-color";

class WinterMaintenceSensorTools extends Component {
  render() {
    const {
      sensorData,
      sensorRouteViseble,
      filterBySenorKey,
      routeSensorKey,
      totalCount,
      winterSensorsFilter,
      onSetWinterSensorssFilter,
      title,
      routeSensorTitle,
      sensorColorKey,
    } = this.props;

    return (
      <div>
        <p> Фильтровать ТС и маршруты по наличию:</p>
        <div className={styles.winterGroupCheckboxContainer}>
          <label>
            <input
              style={{ color: "#408ad4" }}
              type="checkbox"
              checked={winterSensorsFilter[filterBySenorKey]}
              onClick={() => {
                winterSensorsFilter[filterBySenorKey] = !winterSensorsFilter[filterBySenorKey];
                onSetWinterSensorssFilter(winterSensorsFilter);
              }}
            />
            {title}
          </label>

          <div className={styles.dataContainer}>
            <div style={{ position: "absolute", right: "0px" }}>
              <div>
                {sensorData.count} из {totalCount} (ед. т/с)
              </div>
            </div>
          </div>
        </div>

        {sensorRouteViseble ? (
          <div className={styles.winterGroupCheckboxContainer}>
            <ColorPicker
              value={winterSensorsFilter[sensorColorKey]}
              hideTextfield={true}
              onChange={(e) => {
                if (winterSensorsFilter[sensorColorKey] !== `#${e.hex}`) {
                  winterSensorsFilter[sensorColorKey] = `#${e.hex}`;
                  onSetWinterSensorssFilter(winterSensorsFilter);
                }
              }}
            />

            <label>
              <input
                style={{ color: "#408ad4" }}
                type="checkbox"
                checked={winterSensorsFilter[routeSensorKey]}
                onClick={() => {
                  winterSensorsFilter[routeSensorKey] = !winterSensorsFilter[routeSensorKey];
                  onSetWinterSensorssFilter(winterSensorsFilter);
                }}
              />
              {routeSensorTitle}
            </label>

            <div className={styles.dataContainer}>
              <div style={{ position: "absolute", right: "0px" }}>
                <div>
                  {!sensorRouteViseble ? null : sensorData.workCount} из {sensorData.count} (ед. т/с)
                </div>
                <div> {!sensorRouteViseble ? null : sensorData.distance} </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default withWinterMaintence(React.memo(WinterMaintenceSensorTools));
